<template>
    <BreadCrumb PageTitle="Liste des validations tasks" />
     <ListeValidationTask/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeValidationTask from "@/components/ValidationTasks/ListeValidationTask.vue";
  
    export default defineComponent({
      name: "ListeValidationTaskPage",
      components: {
        BreadCrumb,
        ListeValidationTask,
      },
    });
  </script>